import { useNavigate } from 'react-router-dom';

const articleCards = [
  {
    title: 'What Is Superbuy Spreadsheet?',
    readTime: '5 min read',
    desc: 'A complete introduction to the Superbuy Spreadsheet ecosystem. Learn how it works and why thousands of shoppers use it daily.',
    slug: '/superbuy-spreadsheet-guide',
    bg: 'bg-accent-100',
    icon: 'ri-book-open-line',
    iconColor: 'text-accent-600',
  },
  {
    title: 'Superbuy Spreadsheet Safety Guide',
    readTime: '7 min read',
    desc: 'Everything you need to know about using Superbuy Spreadsheet safely. Payment protection, seller verification, and privacy tips.',
    slug: '/superbuy-spreadsheet-safety-guide',
    bg: 'bg-secondary-100',
    icon: 'ri-shield-check-line',
    iconColor: 'text-secondary-600',
  },
  {
    title: 'Best Categories to Start With',
    readTime: '4 min read',
    desc: 'New to Superbuy Spreadsheet? Discover the most popular categories and learn where to find the best deals for beginners.',
    slug: '/superbuy-spreadsheet-categories',
    bg: 'bg-primary-100',
    icon: 'ri-star-line',
    iconColor: 'text-primary-600',
  },
];

export default function ContentSection() {
  const navigate = useNavigate();

  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-wide mb-3">
            Learning Hub
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
            Superbuy Sheet <span className="text-accent-500">Guides</span>
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg">
            Expert resources and comprehensive guides for global shoppers. Master Superbuy Spreadsheet from beginner to advanced.
          </p>
        </div>

        {/* Article Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((card, idx) => (
            <div
              key={idx}
              className="rounded-lg bg-background-50 overflow-hidden group cursor-pointer"
              onClick={() => navigate(card.slug)}
            >
              {/* Card Image Area */}
              <div className={`h-40 md:h-48 ${card.bg} flex items-center justify-center relative overflow-hidden`}>
                <i className={`${card.icon} ${card.iconColor} text-5xl md:text-6xl opacity-40 group-hover:opacity-60 group-hover:scale-110 transition-all duration-500`}></i>
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/60 to-transparent"></div>
              </div>

              {/* Card Content */}
              <div className="p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 mb-4 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{card.readTime}</span>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                    Read Guide
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-10 text-center">
          <button
            onClick={() => navigate('/superbuy-spreadsheet-guide')}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer"
          >
            View All Guides
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}